import type { FC, ReactNode } from 'react'

import { AsciiField } from '@/components/generals/ascii-field'
import { CtaLabel, ChevronIcon } from '@/components/generals/cta'
import { footerQuickLinks, socialLinks, siteConfig } from '@/constants/site'

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='footer' id='contact' data-ground='light'>
            <AsciiField className='footer-ascii-left' seed={53} mask='edge' cell={10} power={1.5} gain={2.1} />
            <AsciiField className='footer-ascii-right' seed={67} mask='edge-r' cell={10} power={1.5} gain={2.1} />

            <div className='footer-rail-top' aria-hidden='true' />

            <div className='footer-cta'>
                <img className='footer-cta-bg' src='/images/footer/cta-bg.jpg' alt='' width={1600} height={485} aria-hidden='true' />

                <div className='footer-cta-row'>
                    <h2 className='footer-cta-title'>
                        Ready to<br />{' '}
                        <span className='footer-cta-strike'>
                            kick ass{' '}
                            <img className='footer-cta-scribble' src='/images/footer/scribble.svg' alt='' width={178} height={68} aria-hidden='true' />{' '}
                            <span className='footer-cta-tag' aria-hidden='true'>Work</span>{' '}
                        </span>{' '}
                        with Native?
                    </h2>

                    <a className='footer-cta-btn' href='/contact'>
                        <CtaLabel text='Work with us' />
                        <ChevronIcon />
                    </a>
                </div>
            </div>

            <div className='footer-grid'>
                <div className='footer-brand'>
                    <div className='footer-brand-top'>
                        <img className='footer-logo' src='/images/native-logo.svg' alt='Native' width={123} height={16} />
                        <p className='footer-tagline'>A better way to make your website stand out.</p>
                    </div>

                    <p className='footer-legal'>
                        <span className='footer-legal-item'>© 2026 Native Agency</span>
                        <span className='footer-legal-sep' aria-hidden='true'>·</span>
                        <a className='footer-legal-link' href='/terms'>Terms of Service</a>
                        <span className='footer-legal-sep' aria-hidden='true'>·</span>
                        <a className='footer-legal-link' href='/privacy'>Privacy Policy</a>
                    </p>
                </div>

                <nav className='footer-nav' aria-label='Footer'>
                    <div className='footer-col'>
                        <p className='footer-col-title'>Quick Links</p>
                        <ul className='footer-links'>
                            {footerQuickLinks.map((link) => (
                                <li key={link.href}>
                                    <a className='footer-link' href={link.href}>{link.label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className='footer-col'>
                        <p className='footer-col-title'>Socials</p>
                        <ul className='footer-links'>
                            {socialLinks.map((link) => (
                                <li key={link.href}>
                                    <a className='footer-link' href={link.href} target='_blank' rel='noopener'>{link.label}</a>
                                </li>
                            ))}
                            <li>
                                <a className='footer-link' href={`mailto:${siteConfig.email}`}>Email</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>

            <div className='footer-mark' aria-hidden='true'>
                <img className='footer-mark-img' src='/images/native-logo.svg' alt='' width={423} height={55} />
                <div className='footer-mark-veil' />
            </div>

            <div className='footer-rail-bottom' aria-hidden='true' />
        </footer>
    )
}
